/**
 * @flow
 * @relayHash 02a50c990912466c364f97e7dbee94cb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VueExclusivePermissionDeleteMutationVariables = {|
  vueExclusivePermissionId?: ?string
|};
export type VueExclusivePermissionDeleteMutationResponse = {|
  +deleteVueExclusivePermission: ?{|
    +account: ?{|
      +id: string
    |}
  |}
|};
export type VueExclusivePermissionDeleteMutation = {|
  variables: VueExclusivePermissionDeleteMutationVariables,
  response: VueExclusivePermissionDeleteMutationResponse,
|};
*/


/*
mutation VueExclusivePermissionDeleteMutation(
  $vueExclusivePermissionId: ID
) {
  deleteVueExclusivePermission(vueExclusivePermissionId: $vueExclusivePermissionId) {
    account {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "vueExclusivePermissionId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteVueExclusivePermission",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "vueExclusivePermissionId",
        "variableName": "vueExclusivePermissionId"
      }
    ],
    "concreteType": "DeleteVueExclusivePermission",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "account",
        "storageKey": null,
        "args": null,
        "concreteType": "AccountNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VueExclusivePermissionDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "VueExclusivePermissionDeleteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "VueExclusivePermissionDeleteMutation",
    "id": null,
    "text": "mutation VueExclusivePermissionDeleteMutation(\n  $vueExclusivePermissionId: ID\n) {\n  deleteVueExclusivePermission(vueExclusivePermissionId: $vueExclusivePermissionId) {\n    account {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4c768d0ed6b56adad3aef8c27ee814fc';
module.exports = node;
